import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    base: process.env.BASE_URL,
    routes: [
        // ======================
        // Blank Layout
        // ======================    
        {
            path: '',
            component: () => import('./layout/blank/Blank.vue'),
            // ======================
            // Theme routes / pages
            // ======================
            children: [{
                path: '/',
                redirect: '/login',
                meta: { requiresVisitor: true }
            }, {
                path: '/login',
                name: 'Login',
                index: 1,
                component: () => import('./views/authentication/Login.vue'),
                meta: { requiresVisitor: true }
            }, {
                path: '/error404',
                name: 'Error 404',
                index: 2,
                component: () => import('./views/authentication/Error404.vue')
            }]
        },
        {
            // ======================
            // Full Layout
            // ======================
            path: '',
            component: () => import('./layout/full/MainContainer.vue'),
            // ======================
            // Theme routes / pages
            // ======================
            children: [{
                path: '/dashboards/classic-dashboard',
                name: 'Dashboard',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/dashboards/classic-dashboard'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/dashboards/classic-dashboard/ClassicDashboard.vue')
            },{
                path: '/master/customer',
                name: 'customerlist',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Master Customer',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/customer/List.vue')
            },{
                path: '/master/customer/input',
                name: 'customerinput',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Master Customer',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/customer/Input.vue')
            },{
                path: '/crm/customer/edit/:ref',
                name: 'customeredit',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/customer/Input.vue')
            },{
                path: '/crm/quotation',
                name: 'quotation',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/quotation/List.vue')
            },{
                path: '/crm/quotationinput',
                name: 'quotationinput',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/quotation/Input.vue')
            },{
                path: '/crm/quotationinput/edit/:ref',
                name: 'quotationedit',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/quotation/Input.vue')
            },{
                path: '/crm/so',
                name: 'so',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/so/List.vue')
            },{
                path: '/crm/soinput',
                name: 'soinput',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/so/Input.vue')
            },{
                path: '/crm/soinput/edit/:ref',
                name: 'soedit',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/so/Input.vue')
            },{
                path: '/crm/sr',
                name: 'sr',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/sr/List.vue')
            },{
                path: '/crm/srinput',
                name: 'srinput',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/sr/Input.vue')
            },{
                path: '/crm/srinput/edit/:ref',
                name: 'sredit',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/sr/Input.vue')
            },{
                path: '/crm/wo',
                name: 'wo',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/wo/List.vue')
            },{
                path: '/crm/woinput',
                name: 'woinput',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/wo/Input.vue')
            },{
                path: '/crm/produksi',
                name: 'produksi',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/produksi/List.vue')
            },{
                path: '/crm/produksiinput',
                name: 'produksiinput',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/produksi/Input.vue')
            },{
                path: '/crm/produksiinput/:ref',
                name: 'produksiedit',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/produksi/Edit.vue')
            },{
                path: '/crm/cutting',
                name: 'cutting',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/cutting/List.vue')
            },{
                path: '/crm/cuttinginput',
                name: 'cuttinginput',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/cutting/Input.vue')
            },{
                path: '/crm/cuttinginput/:ref',
                name: 'cuttingedit',
                index: 1,
                meta: {
                    breadcrumb: [{
                        title: 'Dashboards',
                        url: '/master/customer'
                    },
                    {
                        title: 'Classic Dashboard',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/crm/cutting/Input.vue')
            },{
                path: '/master/tandatangan',
                name: 'ttdlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/tandatangan/List.vue')
            },{
                path: '/master/tandatangan/input',
                name: 'ttdinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/tandatangan/Input.vue')
            },{
                path: '/master/tandatangan/edit/:ref',
                name: 'ttdedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Tandatangan',
                        url: '/master/tandatangan/edit/:ref'
                    },
                    {
                        title: 'Tanda Tangan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/tandatangan/Input.vue')
            },{
                path: '/master/rekanan',
                name: 'rekananlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Rekanan',
                        url: '/master/rekanan'
                    },
                    {
                        title: 'Rekanan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/rekanan/List.vue')
            },{
                path: '/master/rekanan/input',
                name: 'rekananinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Rekanan',
                        url: '/master/rekanan'
                    },
                    {
                        title: 'Rekanan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/rekanan/Input.vue')
            },{
                path: '/master/rekanan/edit/:ref',
                name: 'rekananedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Rekanan',
                        url: '/master/rekanan/edit/:ref'
                    },
                    {
                        title: 'Rekanan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/rekanan/Input.vue')
            },{
                path: '/master/inventory',
                name: 'inventorylist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Inventory',
                        url: '/master/inventory'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/inventory/List.vue')
            },{
                path: '/master/inventory/input',
                name: 'inventoryinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Inventory',
                        url: '/master/inventory'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/inventory/Input.vue')
            },{
                path: '/master/inventory/edit/:ref',
                name: 'inventoryedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Inventory',
                        url: '/master/inventory/edit/:ref'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/inventory/Input.vue')
            },{
                path: '/master/pegawai',
                name: 'pegawailist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Pegawai',
                        url: '/master/pegawai'
                    },
                    {
                        title: 'Pegawai',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/pegawai/List.vue')
            },{
                path: '/master/pegawai/input',
                name: 'pegawaiinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Pegawai',
                        url: '/master/pegawai'
                    },
                    {
                        title: 'Pegawai',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/pegawai/Input.vue')
            },{
                path: '/master/pegawai/edit/:ref',
                name: 'pegawaiedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Pegawai',
                        url: '/master/pegawai/edit/:ref'
                    },
                    {
                        title: 'Inventory',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/pegawai/Input.vue')
            },{
                path: '/master/perkiraan',
                name: 'perkiraanlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Perkiraan',
                        url: '/master/perkiraan'
                    },
                    {
                        title: 'Perkiraan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/perkiraan/List.vue')
            },{
                path: '/master/perkiraan/input',
                name: 'perkiraaninput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Perkiraan',
                        url: '/master/perkiraan'
                    },
                    {
                        title: 'Perkiraan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/perkiraan/Input.vue')
            },{
                path: '/master/perkiraan/edit/:ref',
                name: 'perkiraanedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Perkiraan',
                        url: '/master/perkiraan/edit/:ref'
                    },
                    {
                        title: 'Perkiraan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/perkiraan/Input.vue')
            },{
                path: '/master/role',
                name: 'rolelist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/role'
                    },
                    {
                        title: 'Role',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/role/List.vue')
            },{
                path: '/master/role/input',
                name: 'roleinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/role'
                    },
                    {
                        title: 'Role',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/role/Input.vue')
            },{
                path: '/master/role/edit/:ref',
                name: 'roleedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/role/edit/:ref'
                    },
                    {
                        title: 'Role',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/role/Input.vue')
            },{
                path: '/master/user',
                name: 'userlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'User',
                        url: '/master/user'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/user/List.vue')
            },{
                path: '/master/user/input',
                name: 'userinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'User',
                        url: '/master/user'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/user/Input.vue')
            },{
                path: '/master/user/:ref',
                name: 'useredit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Role',
                        url: '/master/user/edit/:ref'
                    },
                    {
                        title: 'User',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/master/user/Input.vue')
            },{
                path: '/keuangan/invoice',
                name: 'invoicelist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/invoicing/List.vue')
            },
            {
                path: '/keuangan/invoice/edit/:ref',
                name: 'invoiceedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/invoicing/Input.vue')
            },
            {
                path: '/keuangan/invoicebank/edit/:ref',
                name: 'invoicebankedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/invoicing/BankInput.vue')
            },
            {
                path: '/keuangan/retur',
                name: 'returindex',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/retur/List.vue')
            },
            {
                path: '/keuangan/returlist',
                name: 'returlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/retur/ReturList.vue')
            },
            {
                path: '/keuangan/retur/input/:ref',
                name: 'returinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/retur/Input.vue')
            },
            {
                path: '/keuangan/piutang',
                name: 'piutanglist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/piutang/List.vue')
            },
            {
                path: '/keuangan/piutang/input',
                name: 'piutanginput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/piutang/Input.vue')
            },
            {
                path: '/keuangan/piutang/edit/:ref',
                name: 'piutangedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/piutang/Input.vue')
            },
            {
                path: '/keuangan/ttinvoice',
                name: 'ttinvoicelist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/ttinvoice/List.vue')
            },
            {
                path: '/keuangan/ttinvoice/input',
                name: 'ttinvoiceinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/ttinvoice/Input.vue')
            },
            {
                path: '/keuangan/bankin',
                name: 'bankinlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/bankin'
                    },
                    {
                        title: 'Bank Masuk',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/bankin/List.vue')
            },            {
                path: '/keuangan/bankin/input',
                name: 'bankininput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/bankin'
                    },
                    {
                        title: 'Input Bank Masuk',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/bankin/Input.vue')
            },
            {
                path: '/keuangan/bankin/edit/:ref',
                name: 'bankinedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/bankin'
                    },
                    {
                        title: 'Edit Bank Masuk',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/bankin/Input.vue')
            },
                {
                    path: '/keuangan/bankout',
                    name: 'bankoutlist',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'JRA',
                            url: '/jurnal/jra'
                        },
                            {
                                title: 'Jurnal Rekening Air',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/keuangan/bankout/List.vue')
                },{
                    path: '/keuangan/bankout/input',
                    name: 'bankoutinput',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'JRA',
                            url: '/jurnal/jra'
                        },
                            {
                                title: 'Jurnal Rekening Air',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/keuangan/bankout/Input.vue')
                },
                {
                    path: '/keuangan/bankout/edit/:ref',
                    name: 'bankoutedit',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'JRA',
                            url: '/jurnal/jra'
                        },
                            {
                                title: 'Jurnal Rekening Air',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/keuangan/bankout/Input.vue')
                },
            {
                path: '/keuangan/blokir',
                name: 'blokir',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/blokir/List.vue')
            },
            {
                path: '/keuangan/blokir/input',
                name: 'blokirinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/blokir/Input.vue')
            },
            {
                path: '/keuangan/nomorfp',
                name: 'nofplist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/nomorfp/List.vue')
            },
            {
                path: '/keuangan/nomorfp/input',
                name: 'nofpinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/nomorfp/Input.vue')
            },
            {
                path: '/keuangan/voucher',
                name: 'voucherlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/voucher'
                    },
                    {
                        title: 'Voucher',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/voucher/List.vue')
            },
            {
                path: '/keuangan/voucher/input',
                name: 'voucherinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/voucher'
                    },
                    {
                        title: 'Input Voucher',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/voucher/Input.vue')
            },
            {
                path: '/keuangan/voucher/edit/:ref',
                name: 'voucheredit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/voucher'
                    },
                    {
                        title: 'Edit Voucher',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/voucher/Input.vue')
            },
            {
                path: '/keuangan/convertFp',
                name: 'convertFp',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/nomorfp/ConvertFp.vue')
            },
            {
                path: '/persetujuan/unblokir',
                name: 'unblokir',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'JRA',
                        url: '/jurnal/jra'
                    },
                    {
                        title: 'Jurnal Rekening Air',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/persetujuan/unblokir/List.vue')
            },
            {
                path: '/inventory/po',
                name: 'polist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/po/Index.vue')
            },{
                path: '/inventory/po/input',
                name: 'poinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/po/Input.vue')
            },{
                path: '/inventory/po/edit/:ref',
                name: 'poedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/po/Input.vue')
            },{
                path: '/inventory/bpb',
                name: 'bpblist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpb/Index.vue')
            },{
                path: '/inventory/sj',
                name: 'sjlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/sj/List.vue')
            },{
                path: '/inventory/sjlist',
                name: 'sjcreated',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/sj/ListSj.vue')
            },{
                path: '/inventory/sj/input/:ref',
                name: 'sjinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/sj/Form.vue')
            },{
                path: '/inventory/sj/edit/:ref',
                name: 'sjedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/sj/FormEdit.vue')
            },{
                path: '/inventory/sr',
                name: 'sjsrlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/sr/List.vue')
            },{
                path: '/inventory/srlist',
                name: 'sjsrcreated',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/sr/ListSj.vue')
            },{
                path: '/inventory/sr/input/:ref',
                name: 'sjsrinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/sr/Form.vue')
            },{
                path: '/inventory/sr/edit/:ref',
                name: 'sjsredit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/sr/FormEdit.vue')
            },{
                path: '/inventory/bpb/input',
                name: 'bpbinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpb/Input.vue')
            },{
                path: '/inventory/bpb/edit/:ref',
                name: 'bpbedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpb/Edit.vue')
            },{
                path: '/inventory/hitung',
                name: 'hitungstok',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/Hitungstok.vue')
            },{
                path: '/inventory/saldoAwal',
                name: 'hitungsaldoawal',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/Hitungsaldoawal.vue')
            },
            {
                path: '/posting/bpb',
                name: 'postingbpblist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Tambah stok (BPB)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpb/PostingIndex.vue')
            },{
                path: '/posting/bpb/edit/:ref',
                name: 'postingbpbedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Posting Tambah stok (BPB)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'Posting Tambah stok (BPB)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpb/PostingInput.vue')
            },
            {
                path: '/inventory/bpp',
                name: 'bpplist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        url: '/inventory/bpp'
                    },
                    {
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpp/Index.vue')
            },{
                path: '/inventory/bpp/input',
                name: 'bppinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        url: '/inventory/bpb'
                    },
                    {
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpp/Input.vue')
            },{
                path: '/inventory/bpp/edit/:ref',
                name: 'bppedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        url: '/inventory/bpp/edit/:ref'
                    },
                    {
                        title: 'Perminataan Pemakaian Barang (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpp/Input.vue')
            },

            {
                path: '/posting/bpp',
                name: 'postingbpplist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'POSTING PEMAKAIAN (BPP)',
                        url: '/posting/bpp'
                    },
                    {
                        title: 'POSTING PEMAKAIAN (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpp/PostingIndex.vue')
            },{
                path: '/posting/bpp/edit/:ref',
                name: 'postingbppedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'POSTING PEMAKAIAN (BPP)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'POSTING PEMAKAIAN (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/inventory/bpp/PostingInput.vue')
            },
            {
                path: '/jurnal/ju',
                name: 'julist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'POSTING PEMAKAIAN (BPP)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'POSTING PEMAKAIAN (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/ju/Index.vue')
            },
            {
                path: '/jurnal/ju/input',
                name: 'juinput',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'POSTING PEMAKAIAN (BPP)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'POSTING PEMAKAIAN (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/ju/Input.vue')
            },
            {
                path: '/jurnal/ju/input/:ref',
                name: 'juedit',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'POSTING PEMAKAIAN (BPP)',
                        url: '/inventory/bpb/edit/:ref'
                    },
                    {
                        title: 'POSTING PEMAKAIAN (BPP)',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/ju/Input.vue')
            },
                {
                    path: '/aktiva/daftar',
                    name: 'aktivalist',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'Daftar Aktiva',
                            url: '/aktiva/daftar'
                        },
                            {
                                title: 'Daftar Aktiva',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/aktiva/AktivaList.vue')
                },{
                    path: '/aktiva/input',
                    name: 'aktivainput',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'Input Aktiva',
                            url: '/aktiva/input'
                        },
                            {
                                title: 'Daftar Aktiva',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/aktiva/AktivaForm.vue')
                },{
                    path: '/aktiva/edit/:ref',
                    name: 'aktivaedit',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'Input Aktiva',
                            url: '/aktiva/edit/:ref'
                        },
                            {
                                title: 'Daftar Aktiva',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/aktiva/AktivaForm.vue')
                },{
                    path: '/aktiva/koreksi',
                    name: 'koreksiaktivalist',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'Daftar Aktiva',
                            url: '/aktiva/koreksi'
                        },
                            {
                                title: 'Daftar Aktiva',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/aktiva/KoreksiList.vue')
                },{
                    path: '/aktiva/koreksiinput',
                    name: 'koreksiaktivainput',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'Input Aktiva',
                            url: '/aktiva/input'
                        },
                            {
                                title: 'Daftar Aktiva',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/aktiva/KoreksiForm.vue')
                },{
                    path: '/aktiva/susut',
                    name: 'aktivasusut',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'Penyusutan Aktiva',
                            url: '/aktiva/susut'
                        },
                            {
                                title: 'Penyusutan Aktiva',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/aktiva/SusutList.vue')
                },{
                    path: '/aktiva/susutproses',
                    name: 'susutproses',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'Penyusutan Aktiva',
                            url: '/aktiva/susutproses'
                        },
                            {
                                title: 'Penyusutan Aktiva',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/aktiva/SusutForm.vue')
                },{
                    path: '/aktiva/hapus',
                    name: 'hapusaktivainput',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'Hapus Aktiva',
                            url: '/aktiva/hapus'
                        },
                            {
                                title: 'Hapus Aktiva',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/aktiva/HapusForm.vue')
                },{
                    path: '/aktiva/posting',
                    name: 'aktivaposting',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'Daftar Aktiva',
                            url: '/aktiva/posting'
                        },
                            {
                                title: 'Daftar Aktiva',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/aktiva/JurnalList.vue')
                },{
                    path: '/aktiva/posting/input/:ref',
                    name: 'aktivapostinginput',
                    index: 2,
                    meta: {
                        breadcrumb: [{
                            title: 'Daftar Aktiva',
                            url: '/aktiva/posting/input/:ref'
                        },
                            {
                                title: 'Daftar Aktiva',
                                active: true
                            },
                        ],
                        requiresAuth: true
                    },
                    component: () => import('./views/aktiva/AktivaJurnalForm.vue')
                },

            {
                path: '/report/index',
                name: 'report',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Laporan',
                        url: '/report/index'
                    },
                    {
                        title: 'Laporan',
                        active: true
                    },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/report/Index.vue')
            },
            {
                path: '/jurnal/ju',
                name: 'julist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'DVUD',
                        url: '/jurnal/dvud'
                    },
                        {
                            title: 'Voucher Utang',
                            active: true
                        },
                    ],
                    requiresAuth: true
                },
                component: () => import('./views/jurnal/ju/Index.vue')
            },
            {
                path: '/akuntansi/posting-penjualan',
                name: 'postingpenjualan',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Akuntansi',
                        url: '/akuntansi/posting-penjualan'
                    },
                        {
                            title: 'Posting Penjualan',
                            active: true
                        }],
                    requiresAuth: true
                },
                component: () => import('./views/akuntansi/PostingPenjualan.vue')
            },
            // ====================== Account Payable ======================
            {
                path: '/keuangan/accountpayable',
                name: 'aplist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/accountpayable'
                    }, {
                        title: 'Account Payable',
                        active: true
                    }],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/accountpayable/List.vue')
            },
            {
                path: '/keuangan/accountpayable/input',
                name: 'apinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/accountpayable'
                    }, {
                        title: 'Input Account Payable',
                        active: true
                    }],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/accountpayable/Input.vue')
            },
            {
                path: '/keuangan/accountpayable/edit/:ref',
                name: 'apedit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/accountpayable'
                    }, {
                        title: 'Edit Account Payable',
                        active: true
                    }],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/accountpayable/Input.vue')
            },
            // ====================== Account Receivable ======================
            {
                path: '/keuangan/accountreceivable',
                name: 'arlist',
                index: 2,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/accountreceivable'
                    }, {
                        title: 'Account Receivable',
                        active: true
                    }],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/accountreceivable/List.vue')
            },
            {
                path: '/keuangan/accountreceivable/input',
                name: 'arinput',
                index: 3,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/accountreceivable'
                    }, {
                        title: 'Input Account Receivable',
                        active: true
                    }],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/accountreceivable/Input.vue')
            },
            {
                path: '/keuangan/accountreceivable/edit/:ref',
                name: 'aredit',
                index: 4,
                meta: {
                    breadcrumb: [{
                        title: 'Keuangan',
                        url: '/keuangan/accountreceivable'
                    }, {
                        title: 'Edit Account Receivable',
                        active: true
                    }],
                    requiresAuth: true
                },
                component: () => import('./views/keuangan/accountreceivable/Input.vue')
            },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/Error404'
        }
    ]
})

import NProgress from 'nprogress';

function isloggedIn(){
    return store.getters.getLoggedin;
}

/*router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!isloggedIn()) {
        next({
            name: 'Login'
        })
        } else {
        next()
        }
    } else if (to.matched.some(record => record.meta.requiresVisitor)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (isloggedIn()) {
        next({
            name: 'Dashboard'
        })
        } else {
        next()
        }
    } else {
        next() // make sure to always call next()!
    }
})*/

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        NProgress.start()
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!isloggedIn()) {
        next({
            name: 'Login'
        })
        } else {
        next()
        }
    } else if (to.matched.some(record => record.meta.requiresVisitor)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (isloggedIn()) {
        next({
            name: 'Dashboard'
        })
        } else {
        next()
        }
    } 
    next()
})

router.afterEach(() => {
    // Complete the animation of the route progress bar.
    NProgress.done()
})
export default router
